import {TipoDocumentoDTO} from "./tipoDocumento.dto";
import {DocumentoDTO} from "./documento.dto";

export class DocumentoEmitterDTO {

    documento: DocumentoDTO;
    acao: string;
}
